import { Box, Flex } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import React from 'react'
import { Footer } from 'components/Footer'
import { NavBar } from 'components/NavBar'
import { UpdatedRpcModalAnnouncement } from 'components/UpdatedRpcAnnouncement'
import { Routes } from 'constants/routes'
import { PAGE_OFFSET_X } from 'lib/chakra/constants'
import { SubHeader } from './SubHeader'

type DetailLayoutProps = {
  children?: React.ReactNode
}

export const DetailLayout = ({ children }: DetailLayoutProps) => {
  const router = useRouter()

  return (
    <Flex minH="100vh" flexDir="column" justifyContent="space-between">
      <Box>
        <NavBar />
        <UpdatedRpcModalAnnouncement />
        {router.pathname !== Routes.stats() && <SubHeader />}
        <Box px={PAGE_OFFSET_X} pt={8}>
          {children}
        </Box>
      </Box>
      <Footer />
    </Flex>
  )
}
